import { accordion } from './modules/accordion.js';
import { anchorScroll } from './modules/anchorScroll.js';
import { cardAnimate } from './modules/cardAnimate.js';
import { contactPanel } from './modules/contactPanel.js';
import { galleryMarquee } from './modules/galleryMarquee.js';
import { header } from './modules/header.js';
import { headingUpdate } from './modules/headingUpdate.js';
import { lenisScroll } from './modules/lenis.js';
import { mobileNav } from './modules/mobileNav.js';
import { parallaxImage } from './modules/parallaxImage.js';
import { projectSlider } from './modules/projectSlider.js';
import { teamOverlay } from './modules/teamOverlay.js';
import { textReveal } from './modules/textReveal.js';
import { timeline } from './modules/timeline.js';
import { fadeUp } from './modules/fadeUp.js';


accordion();
anchorScroll();
cardAnimate();
contactPanel();
lenisScroll();
header();
headingUpdate();
galleryMarquee();
mobileNav();
textReveal();
parallaxImage();
projectSlider();     
teamOverlay(); 
textReveal(); 
timeline();
fadeUp();
